if (!customElements.get("countdown-clock")) {
  customElements.define(
    "countdown-clock",
    class CountdownClock extends HTMLElement {
      constructor() {
        super();
        this.hoursEl = null;
        this.minutesEl = null;
        this.secondsEl = null;
        this.intervalId = null;
      }

      connectedCallback() {
        this.hoursEl = this.querySelector(".countdown-hours");
        this.minutesEl = this.querySelector(".countdown-minutes");
        this.secondsEl = this.querySelector(".countdown-seconds");

        this.updateCountdown();
        this.intervalId = setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      }

      getTimeUntilNoon() {
        const now = new Date();
        const amsterdamTime = new Date(
          now.toLocaleString("en-US", { timeZone: "Europe/Amsterdam" })
        );

        const noonToday = new Date(amsterdamTime);
        noonToday.setHours(12, 0, 0, 0);

        let diff = noonToday - amsterdamTime;

        if (diff <= 0) {
          const noonTomorrow = new Date(amsterdamTime);
          noonTomorrow.setDate(noonTomorrow.getDate() + 1);
          noonTomorrow.setHours(12, 0, 0, 0);
          diff = noonTomorrow - amsterdamTime;
        }

        return diff;
      }

      updateCountdown() {
        const diff = this.getTimeUntilNoon();

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, "0");
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, "0");
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, "0");
      }
    },
  );
}
